import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=3a80d7e7"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports